import { FC } from "react";
import { useTranslation } from "react-i18next";
import GallerySlider from "../../resources/components/GallerySlider";
import GallerySlide from "../../resources/components/GallerySlide";

const GallerySection: FC = () => {
    const { t } = useTranslation();

    return (
        <div id="gallery" className="relative py-[110px] dmax2:py-[60px] tmax4:!pb-[127px]">
            <div className="relative mx-auto dmin2:w-[1280px] di8:w-[1138px] di7:w-[960px] ti3:w-[860px] td8:w-[767px] ti7:w-[600px] ti8:w-[500px] mi2:w-[440px] mi1:w-[360px] mi5:w-[320px]">
                <div className="mb-[50px] dmax2:mb-[30px]">
                    <h2 className="H24B mr-5">{t("gallerySection.title").toUpperCase()}</h2>
                    <p className="H20 dmax2:H16 text-[#848484] ti7:w-[380px] mt-4">{t("gallerySection.text1")}</p>
                </div>
                <GallerySlider>
                    {Array.from({ length: 17 }, (_, index) => (
                        <GallerySlide key={index} index={index + 1} />
                    ))}
                </GallerySlider>
            </div>
        </div>
    );
};

export default GallerySection;
